import { getSplitUserAttributes, isSplitTreatmentOn, splitTreatmentNames, TypedSplitTreatments } from '$Utilities/split-io-sdk';
import { ISplitTreatmentsChildProps } from '@splitsoftware/splitio-react/types/types';
import { VideoEventDetailsPage } from '$Pages/VideoEventDetails/VideoEventDetails';
import { React } from '../../Imports';
import VideoEventHeaderSubText from '$Components/Shared/VideoEventHeaderSubText';
import useExtractEventId from '$Utilities/hooks/useExtractEventId';
import { VideoRecallPage } from '$Pages/VideoRecall/VideoRecall';
import { useLocation } from 'react-router-dom';
import { useVideoEventNavigation } from '$Utilities/hooks/useVideoEventNavigation';
import { CircularProgress } from 'MaterialUIComponents';
import { ConfigService } from '$State/ConfigFreezerService';

const VideoRecallRoute = () => {
    const { onSelectVideoEvent } = useVideoEventNavigation();
    const location = useLocation();
    const eventId = location.state?.eventId;
    const subText = VideoEventHeaderSubText();
    const extractEventId = useExtractEventId(eventId);

    // Check both location.search and location.hash for eventId
    const searchParam = ConfigService.isRunningGeotabIntegrated() ? location.hash : location.search;
    const delimiter = ConfigService.isRunningGeotabIntegrated() ? ',eventId:' : '?eventId=';
    const selectedEventId = extractEventId(searchParam, delimiter);

    return selectedEventId ? (
        renderVideoEventDetails(selectedEventId, true, onSelectVideoEvent, subText)
    ) : (
        <TypedSplitTreatments
            names={[
                splitTreatmentNames.showInactiveVehicles,
                splitTreatmentNames.videoRecallPreview,
                splitTreatmentNames.videoRecallRedesignV2,
            ]}
            attributes={getSplitUserAttributes()}
        >
            {({ treatments, isReady, isTimedout }: ISplitTreatmentsChildProps) => {
                if (!isReady && !isTimedout) return <CircularProgress />;

                const isShowInactiveVehiclesSplitOn = isSplitTreatmentOn(treatments[splitTreatmentNames.showInactiveVehicles]);
                const isVideoRecallPreviewOn = isSplitTreatmentOn(treatments[splitTreatmentNames.videoRecallPreview]);
                const isVideoRecallRedesignV2SplitOn = isSplitTreatmentOn(treatments[splitTreatmentNames.videoRecallRedesignV2]);

                return (
                    <VideoRecallPage
                        onSelectVideoEvent={onSelectVideoEvent}
                        isShowInactiveVehiclesSplitOn={isShowInactiveVehiclesSplitOn}
                        isVideoRecallPreviewOn={isVideoRecallPreviewOn}
                        isVideoRecallRedesignV2SplitOn={isVideoRecallRedesignV2SplitOn}
                    />
                );
            }}
        </TypedSplitTreatments>
    );
};

export default VideoRecallRoute;

const renderVideoEventDetails = (
    selectedEvent: string,
    isVideoRecall: boolean,
    onSelectVideoEvent: (value: string, goBack: boolean) => void,
    subText: string,
) => {
    return (
        <VideoEventDetailsPage
            eventId={selectedEvent}
            onSelectVideoEvent={onSelectVideoEvent}
            isVideoRecall={isVideoRecall}
            subText={subText}
        />
    );
};
